<div id="build" [attr.modelleerniveau]="dlModel.effectief_modelleerniveau">
    <div id="topmenubar">
        <!-- de modeltoolbar leest zijn standen en zijn acties zelf: readonly en undo/redo uit DlModel en
             de OpslagService, en nieuw/laden/opslaan/kopiëren/eigenschappen/samenwerken/meekijken bij de
             ModelbeheerService -->
        <dl-model-toolbar></dl-model-toolbar>
        <!-- de modeltitel komt uit DlModel, de werkmodus uit de SamenwerkingService, de projectcode uit
             de SessieService en het voorvoegsel uit de OpslagService; alleen de debugvlag komt van buiten -->
        <dl-model-title [debug]="vlaggen.heeftDebug()"></dl-model-title>
        <!-- de simulatietoolbar vraagt zijn negen acties zelf aan bij de samenwerk-baas -->
        <dl-sim-toolbar [modelleerniveau]="dlModel.effectief_modelleerniveau"
                        [fastestPathAan]="!!dlModel.fastest_path"></dl-sim-toolbar>
    </div>
    <div id="canvasholder">
        <div id="cytocanvasholder"
             [style.right.%]="simulatieStatus.simuleren() ? schermindeling.simulatiedeel() : 0">
            @if (tekstbeschrijvingAan()) {
                <div id="tekstbeschrijving-wrapper"
                     class="dl-draggable-container"
                     dlSleepbaar
                     greep=".dl-tekst-beschrijving-titelbalk"
                     [startTop]="60"
                     [startRechts]="62"
                     binnenGrenzen>
                    <dl-tekst-beschrijving id="tekstbeschrijving"></dl-tekst-beschrijving>
                </div>
            }
            <!-- de tekentools links, met de beginnersmodusknop eronder. Het blok zelf gaat weg zodra er
                 niet gewerkt mag worden — het heeft een eigen achtergrond, en die hoort in een replay of
                 als meekijker niet als leeg vlak te blijven staan. Bij een actieve conditieset blijft het
                 blok wél staan en gaan alleen de drie tools eruit; zo deed `canvas.html` het ook -->
            <div id="sidemenu">
                @if (tekentoolsblokAan()) {
                    <ul id="drawtools">
                        @if (tekentoolsAan()) {
                            <li class="nodemenu_item drawtool entity klikbaar"
                                [title]="'ADD_ENTITY' | translate"
                                (click)="startAddActie($event, 'entity')"></li>
                            @if (dlModel.effectief_modelleerniveau >= 30) {
                                <li class="nodemenu_item drawtool agent klikbaar"
                                    [title]="'ADD_AGENT' | translate"
                                    (click)="startAddActie($event, 'agent')"></li>
                            }
                            @if (dlModel.effectief_modelleerniveau >= 40) {
                                <li class="nodemenu_item drawtool assumption klikbaar"
                                    [title]="'ADD_ASSUMPTION' | translate"
                                    (click)="startAddActie($event, 'assumption')"></li>
                            }
                        }
                        <!-- de instructievideo (knop, picker en overlay) regelt zijn eigen zichtbaarheid -->
                        <dl-video></dl-video>
                    </ul>
                }
                @if (magBeginnersmodusToggle()) {
                    <div id="beginnersmodusToggleBtn"
                         class="feedbackbalkbtn beschikbaar klikbaar"
                         [class.actief]="weergaveInstellingen.beginnersmodusAan()"
                         role="button"
                         [attr.aria-pressed]="weergaveInstellingen.beginnersmodusAan()"
                         (click)="toggleBeginnersmodus()"
                         [title]="(weergaveInstellingen.beginnersmodusAan() ? 'BEGINNERSMODUS.UITSCHAKELEN' : 'BEGINNERSMODUS.INSCHAKELEN') | translate">
                        <span class="fa-solid fa-circle-info" aria-hidden="true"></span>
                    </div>
                }
            </div>

            <!-- het conditiesetpaneel regelt zijn eigen zichtbaarheid via de CondtagService -->
            <dl-condtagpaneel></dl-condtagpaneel>
            <dl-modelcanvas id="cytocanvas"></dl-modelcanvas>
            <!-- de chat: de regels, het chatrecht en het transport zitten in de ChatService -->
            <dl-chat id="chat"></dl-chat>
            <div class="rechtsonderblok">
                <dl-verbindingsstatus></dl-verbindingsstatus>
                <dl-canvasknoppen view="model" [minZoom]="0.1" [maxZoom]="10"
                                  [toonSnapnorm]="toonSnapnorm()"
                                  (snapnorm)="snapNorm()"></dl-canvasknoppen>
            </div>
            <!-- de toastmelding hoort bij het canvas: hij ligt absoluut binnen deze houder -->
            <dl-toast></dl-toast>
            <dl-feedbackbalk [debugNormmatch]="vlaggen.heeftVlag('normmatch_debug')"></dl-feedbackbalk>
            <dl-normbalk [toon]="projectVlaggen.normbalk()"></dl-normbalk>
            <div id="debug">{{debuginfo()}}</div>
            <!-- de replaybalk regelt zijn eigen zichtbaarheid via de ReplayService -->
            <dl-replaybalk></dl-replaybalk>
        </div>
        <div id="simcanvasholder"
             [class.dl-build__sim--open]="simulatieStatus.simuleren()"
             [style.left.%]="schermindeling.modeldeel()">
            <dl-simcanvas id="simcanvas"></dl-simcanvas>
            <div class="rechtsonderblok">
                <dl-canvasknoppen view="sim" [minZoom]="0.25" [maxZoom]="3.5"
                                  [toonNicestates]="true" [toonSnapstates]="true"
                                  (niceStates)="doeSim('niceStates')"
                                  (snapStates)="doeSim('snapStates')"></dl-canvasknoppen>
            </div>
            <dl-splitter id="splitter"></dl-splitter>
        </div>
    </div>
    <!-- de twee docentendashboards openen vanuit de modeltoolbar, die dezelfde services zet -->
    <dl-dashboardv1></dl-dashboardv1>
    <dl-dashboardv2></dl-dashboardv2>
</div>
